import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('classdetail').select()

	if (error) {
		throw new Error('Failed to fetch data')
	}
	return data
}

export async function getDataWithClass(classId, instructorId) {
	console.log('classId', classId, instructorId)
	const { data, error } = await supabase
		.from('classdetail')
		.select()
		.eq('classId', classId)
		.or(`instructorId.eq.${instructorId},subinstructorId.eq.${instructorId}`)
	if (error) {
		console.log('Error', error)

		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getStudentClass(studentId) {
	const { data, error } = await supabase.from('classdetail').select().eq('studentId', studentId)

	if (error) {
		throw new Error('Failed to fetch data')
	}
	console.log('error', error, data)
	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('classdetail').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('classdetail').insert(adata).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	const { data, error } = await supabase.from('classdetail').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('classdetail').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteFromData(ddata) {
	const { data, error } = await supabase.from('classdetail').delete().eq('classId', ddata.classId).eq('studentId', ddata.studentId)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
